import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export function sanitizeReportFilename(name) {
  const base = (name || 'locshark-report').trim().replace(/[^\w\s-]+/g, '').replace(/\s+/g, '-');
  return base || 'locshark-report';
}

export async function downloadReportPdf(element, filename = 'locshark-report.pdf') {
  if (!element) {
    throw new Error('Report content is not ready for export.');
  }

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
  });

  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();
  const imgHeight = (canvas.height * pdfWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 0;

  while (heightLeft > 0) {
    pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
    heightLeft -= pdfHeight;
    if (heightLeft > 0) {
      pdf.addPage();
      position -= pdfHeight;
    }
  }

  const safeName = filename.endsWith('.pdf') ? filename : `${filename}.pdf`;
  pdf.save(safeName);
}

export function downloadReportCsv(sections, filename = 'locshark-report.csv') {
  const rows = [];

  sections.forEach((section, index) => {
    if (index > 0) {
      rows.push('');
    }
    rows.push(section.title);
    rows.push(section.columns.map((col) => col.header).join(','));
    rows.push(
      ...section.rows.map((row) => (
        section.columns.map((col) => `"${String(row[col.key] ?? '').replace(/"/g, '""')}"`).join(',')
      )),
    );
  });

  const blob = new Blob([rows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
